import { StatusCodes } from "http-status-codes"
import { useCallback, useContext, useEffect, useState } from "react"
import { Navigate, useNavigate, useParams } from "react-router-dom"
import { useHashTab } from "../../../../hooks/useHashTab"
import { digitalManagerApi } from "../../../../services/api"
import { DiMaDetailsHeaderProps } from "../../../components/DiMaDetailsHeader"
import { DiMaProgress } from "../../../components/DiMaProgress"
import { DetailsHeaderTabLayout } from "../../../components/Helpers"
import { UserContext } from "../../../context/UserContext"
import { DeviceCategoryGet } from "../../../models/DeviceCategory"
import { CategoryDetails } from "./details_tab/CategoryDetails"
import { CategoryDevices } from "./devices_tab/CategoryDevices"

const returnURL = "/devices#categories"

export function CategoryContainer() {
  const { categoryId } = useParams()
  const { user, isLoadingUser } = useContext(UserContext)
  const navigate = useNavigate()
  const { activeTab, handleTabChange } = useHashTab("details")

  const [deviceCategory, setDeviceCategory] = useState<DeviceCategoryGet>()
  const [reloadEntity, setReloadEntity] = useState<boolean>(true)

  const reloadCategoryContainer = useCallback(() => setReloadEntity(true), [])

  useEffect(() => {
    if (categoryId && reloadEntity === true) {
      digitalManagerApi
        .get<DeviceCategoryGet>(`/deviceCategories/${categoryId}`)
        .then((res) => {
          if (res.status === StatusCodes.OK) {
            setDeviceCategory(res.data)
            setReloadEntity(false)
          }
        })
        .catch(() => {
          navigate(returnURL)
        })
    }
  }, [categoryId, navigate, reloadEntity])

  if (!categoryId) {
    return <Navigate to={returnURL} />
  }

  if (!deviceCategory || isLoadingUser || !user) {
    return <DiMaProgress />
  }

  const detailsHeaderProps: DiMaDetailsHeaderProps = {
    url: returnURL,
    title: deviceCategory.name,
    label: "Device Category",
    subtitle: deviceCategory.name,
    hideCopyToClipboard: true,
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
      <DetailsHeaderTabLayout
        detailsHeaderProps={detailsHeaderProps}
        tabItems={[
          { id: "details", label: "Details" },
          { id: "devices", label: "Devices" },
        ]}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />
      {activeTab === "details" && (
        <CategoryDetails
          deviceCategory={deviceCategory}
          setDeviceCategory={setDeviceCategory}
          user={user}
        />
      )}
      {activeTab === "devices" && (
        <CategoryDevices
          deviceCategory={deviceCategory}
          reloadCategoryContainer={reloadCategoryContainer}
        />
      )}
    </div>
  )
}
